"use client";
import { BannerRep } from "@/api/home";
import Box from "@/components/Box";
import { NoticeBar, Swiper } from "antd-mobile";
import { FC } from "react";
interface Props {
    notices: BannerRep[];
}
const HomeNoticeBar: FC<Props> = (props) => {
    const { notices } = props;

    return (
        <div
            className={
                "my-[0.0694rem] flex items-center overflow-hidden rounded-[.1rem] bg-[#1f2830] px-[.1rem]"
            }
        >
            <div className={"iconfont icon-laba mr-[0.06rem] text-[.14rem] text-[#13de68]"}></div>
            <Swiper
                direction="vertical"
                indicator={() => null}
                style={{ height: "0.36rem" }}
                loop
                autoplay
                autoplayInterval={10000}
            >
                {notices.map((notice, index) => (
                    <Swiper.Item key={index}>
                        <Box
                            none
                            action={notice.action_type}
                            className={"flex h-[0.36rem] w-[100%] items-center"}
                            actionData={notice.action_params}
                        >
                            <NoticeBar
                                delay={0}
                                icon={null}
                                style={{
                                    "--background-color": "none",
                                    "--border-color": "none",
                                    width: "100%",
                                    padding: 0,
                                }}
                                speed={60}
                                bordered
                                content={
                                    <div
                                        dangerouslySetInnerHTML={{ __html: notice.content! }}
                                    ></div>
                                }
                            />
                            {/**/}
                        </Box>
                    </Swiper.Item>
                ))}
            </Swiper>
        </div>
    );
};
export default HomeNoticeBar;
